import { useId, useState, type ReactNode } from "react";

interface Props {
  label: string;
  hideLabel?: string;
  className?: string;
  children: ReactNode;
}

export function InfoToggle({ label, hideLabel = "Hide", className = "", children }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const panelId = useId();
  return (
    <div className={`flex flex-col gap-2.5 ${className}`}>
      <button
        type="button"
        className="inline-flex items-center gap-1.5 w-fit bg-transparent border-0 p-0 text-[13px] text-rs-green cursor-pointer hover:underline"
        aria-expanded={isOpen}
        aria-controls={panelId}
        onClick={() => setIsOpen((wasOpen) => !wasOpen)}
      >
        <span className="material-symbols-sharp text-[18px]" aria-hidden="true">
          info
        </span>
        {isOpen ? hideLabel : label}
      </button>
      {isOpen && (
        <div
          id={panelId}
          className="flex flex-col gap-4 border border-rs-jet border-l-[3px] border-l-rs-green rounded-md px-4 py-3 text-[13px] text-rs-light-gray"
        >
          {children}
        </div>
      )}
    </div>
  );
}
